import { agentPlatformUrl } from '@/utils/environment';

export const isSuperintelligenceEnabled = (): boolean =>
  agentPlatformUrl.length > 0;

/** One agent per AG-UI route; this product is always superintelligence. */
export const superintelligenceEndpoint = (): string =>
  `${agentPlatformUrl.replace(/\/$/, '')}/agui/superintelligence`;

export const ASK_CHOICE_TOOL = 'ask_choice';
